export enum WhatsappTypeEnum {
  INTRODUCE = 'introduce',
  SITE = 'site',
  OXIN_POLAD = 'oxin_polad',
  NEGIN_POLAD = 'negen-polad',
}

export type WhatsappOption = {
  label: string
  value: WhatsappTypeEnum
}

export type Props = {
  defaultPhonNumber?: string
}
